module.exports = __webpack_public_path__ + "static/media/nBJJO5JEUx.1459d4d5.jpg";